import React from 'react';
import { RadarIcon } from 'lucide-react';
import { RADAR_EXAMPLES } from '../../data/ventureContent';
import { Reveal } from '../ui/Reveal';

/** Illustrative Deal Radar list with fictional companies. */
export function DealRadarPreview() {
  return <figure className="overflow-hidden rounded-2xl border border-hairline bg-panel shadow-[0_24px_60px_-40px_rgba(32,22,95,0.3)]" data-id="element-1295" data-mp="eftj3wie02lh">
      <div className="flex items-center justify-between border-b border-hairline bg-surface px-5 py-3" data-id="element-1296" data-mp="3iul0duisx20k">
        <p className="flex items-center gap-2 text-sm font-semibold text-text-primary" data-id="element-1297" data-mp="3dvzwnl4cc07d">
          <RadarIcon className="h-4 w-4 text-lime" aria-hidden="true" data-id="element-1298" data-mp="3rn4uqis28kfl" />
          Deal Radar
        </p>
        <span className="rounded-md bg-[#FDF3E7] px-2 py-0.5 text-[11px] font-semibold text-[#9A5B13]" data-id="element-1299" data-mp="3mwoeys0romq2">Illustrative example</span>
      </div>
      <ul className="divide-y divide-hairline-soft" data-id="element-1300" data-mp="2z5iycan05qep">
        {RADAR_EXAMPLES.map((company, index) => <Reveal key={company.name} as="li" delay={index * 0.08} className="flex items-center gap-4 px-5 py-4" data-id="element-1301" data-mp="2v4qopga7xjhw" data-mpi={index}>
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-elevated text-xs font-semibold text-text-secondary" data-id="element-1302" data-mp="w5k4l33verg2">
              {company.name.slice(0, 2).toUpperCase()}
            </span>
            <div className="min-w-0 flex-1" data-id="element-1303" data-mp="15xznq3qwlm2j">
              <p className="truncate text-sm font-semibold text-text-primary" data-id="element-1304" data-mp="1atooubiknb0y">{company.name}</p>
              <p className="truncate text-xs text-text-tertiary" data-id="element-1305" data-mp="d813qmrkgf4q">
                {company.sector} · {company.stage}
              </p>
            </div>
            <div className="w-24 shrink-0 text-right sm:w-32" data-id="element-1306" data-mp="i7vsokrs6un5">
              <p className="font-mono text-sm font-semibold text-lime" data-id="element-1307" data-mp="n3kkg1xk778w">{company.fit}</p>
              <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-elevated" aria-hidden="true" data-id="element-1308" data-mp="s5a0jvzn2b3u">
                <div className="h-full rounded-full bg-lime" style={{
              width: `${company.fit}%`
            }} data-id="element-1309" data-mp="1yjj0wqv2gvk5" />
              </div>
            </div>
          </Reveal>)}
      </ul>
      <figcaption className="border-t border-hairline-soft px-5 py-3 text-xs text-text-tertiary" data-id="element-1310" data-mp="3gmj83hrusb6">
        Fictional companies and sample fit scores. Scores reflect fit with a thesis, not investment recommendations.
      </figcaption>
    </figure>;
}